<template>
  <div class="form-group">
    <label v-text="formatLabel()" />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="displayValue" />
  </div>
</template>

<script>
import Field from '../field.vue';

export default {
  extends: Field,
  computed: {
    displayValue() {
      return this.format(this.value) || '-';
    },
  },
};
</script>
